import { render } from "./AccountContactModal.vue?vue&type=template&id=113e62c8"
import script from "./AccountContactModal.vue?vue&type=script&lang=ts"
export * from "./AccountContactModal.vue?vue&type=script&lang=ts"
script.render = render

export default script